import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const ClientFlowRoles = ({ wid }) => {
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get(`/console/clients/${wid}/flow-roles`).then(({ data }) => setD(data)).catch(() => setD({ roles: [], users: [] })); }, [wid]);

  const setRole = async (rid, uid) => {
    const roles = d.roles.map((r) => (r.id === rid ? { ...r, user_id: uid } : r));
    setD({ ...d, roles }); setSaving(true);
    try { await api.put(`/console/clients/${wid}/flow-roles`, { assignments: Object.fromEntries(roles.filter((r) => r.user_id).map((r) => [r.id, r.user_id])) }); toast.success("Flow Roles saved"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  if (!d) return <div className="py-10 text-center"><Loader2 className="h-4 w-4 animate-spin text-[#c4c5cc] mx-auto" /></div>;
  return (
    <div className="space-y-3" data-testid="client-flow-roles">
      <p className="text-xs text-[#9FA1A4] flex items-center gap-2">Who plays each Flow Role for this client. New projects and flow imports assign role tasks to these people; unset roles go to the Scheduler.{saving && <Loader2 className="h-3 w-3 animate-spin" />}</p>
      {d.users.length === 0 && <p className="text-xs text-amber-700" data-testid="client-flow-roles-no-team">No agency team is assigned to this client yet. Assign people in the Users & access tab first.</p>}
      {d.roles.length === 0 ? <p className="text-sm text-[#9FA1A4]">No Flow Roles yet. Add them in Settings → Task Flow.</p> : d.roles.map((r) => (
        <div key={r.id} className="flex items-center gap-3 rounded-xl border border-[#f0f0f3] bg-[#FCFCFE] px-3 py-2">
          <span className="text-sm text-[#06060C] flex-1 truncate">{r.name}</span>
          <Select value={r.user_id || "scheduler"} disabled={!d.can_edit || saving} onValueChange={(v) => setRole(r.id, v === "scheduler" ? null : v)}>
            <SelectTrigger data-testid={`client-flow-role-${r.id}`} className="w-48 bg-white border-[#EEEFEF] h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white border-[#EEEFEF] max-h-56"><SelectItem value="scheduler">Scheduler</SelectItem>{d.users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      ))}
      {!d.can_edit && <p className="text-[11px] text-[#9FA1A4]">Only Super Admins can change Flow Roles.</p>}
    </div>
  );
};
